import { ComponentPropsWithoutRef, FC } from 'react';

import { Paper } from '@mui/material';

import ProductList from './components/ProductList';
import Title from './components/Title';

type CartProps = {
  productListProps: ComponentPropsWithoutRef<typeof ProductList>;
  titleProps?: ComponentPropsWithoutRef<typeof Title>;
  currency?: string;
};

const Cart: FC<CartProps> = ({ productListProps, titleProps, currency }) => {
  return (
    <Paper
      sx={{
        p: 2,
        height: 475,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Title {...titleProps} />
      <ProductList {...productListProps} currency={currency} />
    </Paper>
  );
};

export default Cart;
